import { Injectable, OnInit } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Api } from './api';
import { Environment } from '../app.environment';
import { MediaPermisionData } from '../models';

declare const DetectRTC;



@Injectable()
export class HardwareCheckerService {
  mediaSettings: any;
  mediaPermisions: any;
  memdMediaInformaiton: MediaPermisionData;


  constructor(public enviroment: Environment,
              public api: Api) { 
    this.memdMediaInformaiton = new MediaPermisionData();
    try {
      this.mediaSettings = window['DetectRTC'];
      this.mediaPermisions = navigator;
      this.mediaSettings.load(() => {
        this.mediaSettings.hasWebcam; // (has webcam device!) 
        this.mediaSettings.hasMicrophone; // (has microphone device!) 
        this.mediaSettings.hasSpeakers; // (has speakers!) 
        this.mediaSettings.isScreenCapturingSupported;
        this.mediaSettings.isSctpDataChannelsSupported;
        this.mediaSettings.isRtpDataChannelsSupported;
        this.mediaSettings.isAudioContextSupported;
        this.mediaSettings.isWebRTCSupported;
        this.mediaSettings.isDesktopCapturingSupported;
        this.mediaSettings.isMobileDevice;
  
        this.mediaSettings.isWebSocketsSupported;
        this.mediaSettings.isWebSocketsBlocked;
  
        this.mediaSettings.isWebsiteHasWebcamPermissions;        // getUserMedia allowed for HTTPs domain in Chrome? 
        this.mediaSettings.isWebsiteHasMicrophonePermissions;    // getUserMedia allowed for HTTPs domain in Chrome? 
  
        this.mediaSettings.audioInputDevices;    // microphones 
        this.mediaSettings.audioOutputDevices;   // speakers 
        this.mediaSettings.videoInputDevices;
  
        this.mediaSettings.osName;
        this.mediaSettings.osVersion;
  
        this.mediaSettings.browser.name === 'Edge' || 'Chrome' || 'Firefox';
        this.mediaSettings.browser.version;
        this.mediaSettings.browser.isChrome;
        this.mediaSettings.browser.isFirefox;
        this.mediaSettings.browser.isOpera;
        this.mediaSettings.browser.isIE;
        this.mediaSettings.browser.isSafari;
        this.mediaSettings.browser.isEdge;
  
        this.mediaSettings.browser.isPrivateBrowsing; // incognito or private modes 
  
        this.mediaSettings.isCanvasSupportsStreamCapturing;
        this.mediaSettings.isVideoSupportsStreamCapturing;
  
        //this.saveMediaInformationForIntake(this.mediaSettings);
  
  
      });
    } catch (ex) {
    }
    

  }

  ngOnInit() {
   
  }

  saveMediaChangesForIntake(intakeId: number, userId: number, videoSession: string, videoToken: string, isCamOn: boolean, isMicOn: boolean) {
    
    try {
      this.mediaSettings = window['DetectRTC'];
      this.mediaPermisions = navigator;
      this.mediaSettings.load(() => {
        this.mediaSettings.hasWebcam; // (has webcam device!) 
        this.mediaSettings.hasMicrophone; // (has microphone device!) 
        this.mediaSettings.hasSpeakers; // (has speakers!) 
        this.mediaSettings.isScreenCapturingSupported;
        this.mediaSettings.isSctpDataChannelsSupported;
        this.mediaSettings.isRtpDataChannelsSupported;
        this.mediaSettings.isAudioContextSupported;
        this.mediaSettings.isWebRTCSupported;
        this.mediaSettings.isDesktopCapturingSupported;
        this.mediaSettings.isMobileDevice;
  
        this.mediaSettings.isWebSocketsSupported;
        this.mediaSettings.isWebSocketsBlocked;
  
        this.mediaSettings.isWebsiteHasWebcamPermissions;        // getUserMedia allowed for HTTPs domain in Chrome? 
        this.mediaSettings.isWebsiteHasMicrophonePermissions;    // getUserMedia allowed for HTTPs domain in Chrome? 
  
        this.mediaSettings.audioInputDevices;    // microphones 
        this.mediaSettings.audioOutputDevices;   // speakers 
        this.mediaSettings.videoInputDevices;
  
        this.mediaSettings.osName;
        this.mediaSettings.osVersion;
  
        this.mediaSettings.browser.name === 'Edge' || 'Chrome' || 'Firefox';
        this.mediaSettings.browser.version;
        this.mediaSettings.browser.isChrome;
        this.mediaSettings.browser.isFirefox;
        this.mediaSettings.browser.isOpera;
        this.mediaSettings.browser.isIE;
        this.mediaSettings.browser.isSafari;
        this.mediaSettings.browser.isEdge;
  
        this.mediaSettings.browser.isPrivateBrowsing; // incognito or private modes 
  
        this.mediaSettings.isCanvasSupportsStreamCapturing;
        this.mediaSettings.isVideoSupportsStreamCapturing;
  
        //this.saveMediaInformationForIntake(this.mediaSettings);
  
  
      });
    } catch (ex) {
    }

    try {
      let _audioInputDevices: string = '[';
      let _audioOutputDevices: string = '[';
      let _videoInputDevices: string = '[';

      this.mediaSettings.audioInputDevices.forEach(item => {
        _audioInputDevices = _audioInputDevices + JSON.stringify(item) + ',';
      });

      _audioInputDevices = _audioInputDevices + ']';


      this.mediaSettings.audioOutputDevices.forEach(item => {
        _audioOutputDevices = _audioOutputDevices + JSON.stringify(item) + ',';
      });

      _audioOutputDevices = _audioOutputDevices + ']';


      this.mediaSettings.videoInputDevices.forEach(item => {
        _videoInputDevices = _videoInputDevices + JSON.stringify(item) + ',';
      });

      _videoInputDevices = _videoInputDevices + ']';


      this.memdMediaInformaiton.intakeId = Number(intakeId);
      this.memdMediaInformaiton.userId = userId;
      this.memdMediaInformaiton.audioInputDevices = _audioInputDevices;
      this.memdMediaInformaiton.audioOutputDevices = _audioOutputDevices;
      this.memdMediaInformaiton.videoInputDevices = _videoInputDevices;
      this.memdMediaInformaiton.browserName = this.mediaSettings.browser.name;
      this.memdMediaInformaiton.browserVersion = this.mediaSettings.browser.version;
      this.memdMediaInformaiton.hasMicrophone = this.mediaSettings.hasMicrophone;
      this.memdMediaInformaiton.hasSpeakers = this.mediaSettings.hasSpeakers;
      this.memdMediaInformaiton.hasWebCam = this.mediaSettings.hasWebcam;
      this.memdMediaInformaiton.isMobileDevice = this.mediaSettings.isMobileDevice;
      this.memdMediaInformaiton.isPrivateBrowsing = this.mediaSettings.isPrivateBrowsing;
      this.memdMediaInformaiton.isVideoSupportsStreamCapturing = this.mediaSettings.isVideoSupportsStreamCapturing;
      this.memdMediaInformaiton.isWebRTCSupported = this.mediaSettings.isWebRTCSupported;
      this.memdMediaInformaiton.isWebsiteHasMicrophonePermissions = isMicOn;
      this.memdMediaInformaiton.isWebsiteHasWebcamPermissions = isCamOn;
      this.memdMediaInformaiton.isWebSocketsBlocked = this.mediaSettings.isWebSocketsBlocked;
      this.memdMediaInformaiton.meMDApplication = this.enviroment.settings.applicationName;
      this.memdMediaInformaiton.meMDApplicationVersion = this.enviroment.settings.applicationVersion;
      this.memdMediaInformaiton.videoSession = videoSession;
      this.memdMediaInformaiton.videoToken = videoToken;
      this.memdMediaInformaiton.meMDUserType = 'Patient';
      this.api.insertMediaSettingData(this.memdMediaInformaiton).subscribe(res => {
        console.log(JSON.stringify(this.memdMediaInformaiton));
      });
    } catch (error) {
      console.log(error);

    }
  }
  saveMediaInformationForIntake(intakeId: number, userId: number, videoSession: string, videoToken: string) {
  

    try {
      let _audioInputDevices: string = '[';
      let _audioOutputDevices: string = '[';
      let _videoInputDevices: string = '[';

      this.mediaSettings.audioInputDevices.forEach(item => {
        _audioInputDevices = _audioInputDevices + JSON.stringify(item) + ',';
      });

      _audioInputDevices = _audioInputDevices + ']';


      this.mediaSettings.audioOutputDevices.forEach(item => {
        _audioOutputDevices = _audioOutputDevices + JSON.stringify(item) + ',';
      });

      _audioOutputDevices = _audioOutputDevices + ']';


      this.mediaSettings.videoInputDevices.forEach(item => {
        _videoInputDevices = _videoInputDevices + JSON.stringify(item) + ',';
      });

      _videoInputDevices = _videoInputDevices + ']';


      this.memdMediaInformaiton.intakeId = Number(intakeId);
      this.memdMediaInformaiton.userId = userId;
      this.memdMediaInformaiton.audioInputDevices = _audioInputDevices;
      this.memdMediaInformaiton.audioOutputDevices = _audioOutputDevices;
      this.memdMediaInformaiton.videoInputDevices = _videoInputDevices;
      this.memdMediaInformaiton.browserName = this.mediaSettings.browser.name;
      this.memdMediaInformaiton.browserVersion = this.mediaSettings.browser.version;
      this.memdMediaInformaiton.hasMicrophone = this.mediaSettings.hasMicrophone;
      this.memdMediaInformaiton.hasSpeakers = this.mediaSettings.hasSpeakers;
      this.memdMediaInformaiton.hasWebCam = this.mediaSettings.hasWebcam;
      this.memdMediaInformaiton.isMobileDevice = this.mediaSettings.isMobileDevice
      this.memdMediaInformaiton.isPrivateBrowsing = this.mediaSettings.isPrivateBrowsing
      this.memdMediaInformaiton.isVideoSupportsStreamCapturing = this.mediaSettings.isVideoSupportsStreamCapturing
      this.memdMediaInformaiton.isWebRTCSupported = this.mediaSettings.isWebRTCSupported
      this.memdMediaInformaiton.isWebsiteHasMicrophonePermissions = this.mediaSettings.isWebsiteHasMicrophonePermissions
      this.memdMediaInformaiton.isWebsiteHasWebcamPermissions = this.mediaSettings.isWebsiteHasWebcamPermissions
      this.memdMediaInformaiton.isWebSocketsBlocked = this.mediaSettings.isWebSocketsBlocked
      this.memdMediaInformaiton.meMDApplication = this.enviroment.settings.applicationName;
      this.memdMediaInformaiton.meMDApplicationVersion = this.enviroment.settings.applicationVersion;
      this.memdMediaInformaiton.videoSession = videoSession
      this.memdMediaInformaiton.videoToken = videoToken;
      this.memdMediaInformaiton.meMDUserType = 'Patient';
      this.api.insertMediaSettingData(this.memdMediaInformaiton).subscribe(res => {
        console.log(JSON.stringify(this.memdMediaInformaiton));
      });
    } catch (error) {
      console.log(error);

    }


  }



}
